/* unplugin-vue-components disabled */import { render } from "./BannerList.vue?vue&type=template&id=391bab78&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"

import "./BannerList.vue?vue&type=style&index=0&id=391bab78&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391bab78"]])

export default __exports__